export default class SubmissionError extends Error {
  constructor (errors) {
    super('Submit Validation Failed')
    this.errors = errors
    // todo - in firefox line 6 raise Error (captureStackTrace is not a function)
    // Error.captureStackTrace(this, this.constructor)
    this.name = this.constructor.name
    return this
  }
}
